import React from 'react'

import './styles.scss'

const baseClass = 'image-cropper-modal-wrapper'

const ImageCropperWrapper = ({ children }) => <div className={baseClass}>{children}</div>

export default ImageCropperWrapper
